'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '0 0 25 25', width: '100%', height: '100%' },
          _react2.default.createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd', stroke: color, strokeWidth: '1.5' },
            _react2.default.createElement('path', { d: 'M4.23 23.375V24m16.82-.625V24', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            _react2.default.createElement('path', { d: 'M17.793 5.81a1.615 1.615 0 1 1 1.613 1.612 1.616 1.616 0 0 1-1.617-1.616z' }),
            _react2.default.createElement('path', { d: 'M24.117 10.225H1.16V1.392h22.957v8.833zM4.55 4.555v2.51m3.4-2.51v2.51M20 18.04a.78.78 0 1 1-1.56 0 .78.78 0 0 1 1.56 0z', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            _react2.default.createElement('path', { d: 'M23.956 22.458H1v-8.833h22.956v8.833zM4.39 16.756v2.572m3.4-2.572v2.572', strokeLinecap: 'round', strokeLinejoin: 'round' })
          )
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'Server';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/Server.js
// module id = 1090
// module chunks = 0